import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from "../../assets/images/logo.png";
import g1 from "../../assets/images/resource/gallery-01.png";
import g2 from "../../assets/images/resource/gallery-02.png";
import g3 from "../../assets/images/resource/gallery-03.png";
import g4 from "../../assets/images/resource/gallery-04.png";
import g5 from "../../assets/images/resource/gallery-05.png";
import g6 from "../../assets/images/resource/gallery-06.png";
import { faBuilding, faMailBulk, faMailReply, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { fetchGallery } from '../../DataFetchers/fetchGallery';

const FooterTwo = () => {
    const handleSubmit = (e) => {
        e.preventDefault();
    };

    const [gallery, setGallery] = useState([]);
    useEffect(() => {
        fetchGallery().then((data) => {
            setGallery(data.length>6?data.slice(-6):data);
        });
    }, []);

    return (
        <>
            <footer className="main__footer">
                {/* <div className="footer-top two">
                <div className="auto-container">
                    <div className="top-inner">
                        <div className="left__top">
                            <h3>Looking For best IT business solution?</h3>
                        </div>
                        <div className="right__top">
                            <div className="btn-box">
                                <Link to="/contact" className="theme-btn theme-btn-one"><i className="icon-02"></i> Contact Us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
                <div className="footer__one">
                    <div className="footer-widget-section">
                        <div className="auto-container">
                            <div className="row clearfix">
                                <div className="col-lg-6 col-md-12 col-sm-12 footer-column">
                                    <div className="footer-widget footer-logo-widget wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                                        <figure className="footer-logo">
                                            <Link to="/"><img src={Logo} alt="" /></Link>
                                        </figure>
                                        {/* <div className="text">
                                        <p>Our technologies are designed to seamlessly integrate with your existing systems, minimizing disruption and maximizing productivity.</p>
                                    </div> */}
                                        <div className="btn-box">
                                            <Link to="about.html" className="theme-btn theme-btn-one"><i className="icon-02"></i> About Us</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12 footer-column">
                                    <div className="footer-widget office-widget wow fadeInUp animated" data-wow-delay="400ms" data-wow-duration="1500ms">
                                        <div className="widget-title">
                                            <h4>Contact:</h4>
                                        </div>
                                        <div className="widget-content">
                                            <div className="text">
                                                <div className="footer__contact">
                                                    <FontAwesomeIcon icon={faBuilding} style={{ paddingRight: "8px" }} size='sm' />
                                                    <p style={{ lineHeight: "normal", margin: 0 }}>205 Van Buren St, Suite 120<br />Herndon, VA, 20170</p>
                                                </div>
                                            </div>
                                            <Link to="tell:7342726655">
                                                <div className="footer__contact">
                                                    <FontAwesomeIcon icon={faPhone} style={{ paddingRight: "8px" }} size='sm' />
                                                    +1(734) 272-6655
                                                </div>
                                            </Link>
                                            <Link to="mailto:contact@epitomeri.com">
                                                <div className="footer__contact">
                                                    <FontAwesomeIcon icon={faMailBulk} style={{ paddingRight: "8px" }} size='sm' />
                                                    contact@epitomeri.com
                                                </div>
                                            </Link>
                                            <div className='footer__contact footer__contact__social'><Link to={`https://www.linkedin.com/company/epitome-research-and-innovations-inc/`} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faLinkedin} size='2xl' /></Link></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6 col-sm-12 footer-column pr-0">
                                    <div className="footer-widget gallery-widget wow fadeInUp animated" data-wow-delay="600ms" data-wow-duration="1500ms">
                                        <div className="widget-title">
                                            <h4>Gallery</h4>
                                        </div>
                                        <div className="widget_content">
                                            <ul className="instagram_list clearfix">
                                                {gallery.map((item, id) =>
                                                    <li>
                                                        <div className="inner__box">
                                                            <div className="image__box">
                                                                <Link to=""><img src={item.image} alt="" /></Link>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-bottom">
                        <div className="auto-container">
                            <div className="bottom-inner">
                                <div className="copyright">
                                    <p>© 2025 <Link to="/">Epitome Research And Innovations Inc.</Link>  All rights reserved</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default FooterTwo;